module.exports = __webpack_public_path__ + "img/logo_manufacturer.dc8109fb.png";